var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.svgClass,attrs:{"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48"}},[_c('path',{staticStyle:{"fill-rule":"evenodd"},attrs:{"d":"m29.13 21.18-8.6-8.6-2.82 2.84L26.29 24l-8.58 8.58 2.82 2.84 8.6-8.6a4 4 0 0 0 0-5.64z","data-name":"1.-Foundations/Icons/ATAS_Icon_Arrow_Right_XSmall"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }